module.exports = __webpack_public_path__ + "img/exclamation-square.1a7ab1ae.svg";